import Link from "next/link";
import React from "react";

const DEFAULT_SUBTITLE =
  "Related capabilities and domains that often pair with this solution.";

function RelatedSolutionsComponent({
  data,
  title = "Related solutions",
  subtitle = DEFAULT_SUBTITLE,
}) {
  const relatedSolutions = data || [];

  if (relatedSolutions.length === 0) return null;

  return (
    <section className="border-t border-line py-12 md:py-16">
      <div className="container max-w-7xl">
        <div className="mb-8 text-center">
          <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#1c8c80]">
            Explore
          </p>
          <h2 className="syne-font text-2xl font-bold text-ink md:text-3xl">
            {title}
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-ink-muted sm:text-base">
            {subtitle}
          </p>
        </div>

        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {relatedSolutions.map((solution, index) => (
            <Link
              key={solution.slug || index}
              href={`/solutions/${solution.slug}`}
              className="group rounded-xl border border-line bg-surface p-4 no-underline shadow-[0_10px_28px_-20px_rgba(15,28,26,0.2)] transition-all duration-200 hover:-translate-y-0.5 hover:border-[#5aada4]/55"
            >
              <span className="syne-font line-clamp-2 font-medium text-ink transition-colors duration-200 group-hover:text-[#1c8c80]">
                {solution.title}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default RelatedSolutionsComponent;
